import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from './HeaderImage.module.scss';
import { headerData, verticalHeaderData } from '../lib/data';
import HeaderImageCard from './HeaderImageCard';
import VerticalHeaderImageCard from './VerticalHeaderImageCard';


const HeaderImage = () => {
    return (  
        <div  className={styles.content}>
            <Swiper
                modules={[A11y, Autoplay]}
                loop={true}               
                slidesPerView = {1}
                spaceBetween={5}
                centeredSlides={true}
                autoplay={{
                    delay: 3000, 
                    disableOnInteraction: false, 
                }}
                speed={3000} 

                className={styles.slider}>

                {headerData.map((element) => 
                    <SwiperSlide className = {styles.slide} key={element.id}>
                        <HeaderImageCard
                            element={element}
                        >
                        </HeaderImageCard>                         
                    </SwiperSlide>
                )}            
            </Swiper>  
            <Swiper
                modules={[A11y, Autoplay]}              
                loop={true}               
                slidesPerView = {1}
                spaceBetween={5}
                centeredSlides={true}               
                className={styles.vertical__slider}
                autoplay={{
                    delay: 3000, 
                    disableOnInteraction: false,

                }}
                speed={3000} >

                {verticalHeaderData.map((element) => 
                    <SwiperSlide className = {styles.slide} key={element.id}>
                        <VerticalHeaderImageCard
                            element={element}
                        />
                    </SwiperSlide>
                )}            
            </Swiper>  
        </div>
    );
}
export default HeaderImage;